var generateStyle = function generateStyle(componentTheme) {
  return {
    separator: {
      width: '100%',
      margin: "".concat(componentTheme.separatorMargin, " 0"),
      padding: 0,
      borderBottom: "solid ".concat(componentTheme.separatorBorderWidth),
      borderColor: componentTheme.separatorColor
    }
  };
};
export default generateStyle;